import * as net from 'util/Net';

/* @package */
export interface Link {
  url: string;
  id: string;
}

const LinkDAO = {
  fetchPreviews: (urls: Array<string>): JQueryPromise<{data: Array<Link>}> =>
    net.postJSON({
      url: '/1/api/files/link-previews',
      data: {urls},
    }),
};

export default LinkDAO;
